import React from 'react';
import './Button.scss'

interface ButtonProps {
    label: string;
    type?: 'primary' | 'secondary' | 'primary-outline' | 'secondary-outline';
    size?: 'sm' | 'md' | 'lg';
    disabled?: boolean;
    radius?: boolean;
    icon?: string;
    iconPosition?: 'left' | 'right';
    status?: 'success' | 'danger' | 'warning' | 'info' | 'info-light';
    handleClick?: () => void;
}

const Button: React.FC<ButtonProps> = ({ label, type = 'primary', size = 'md', handleClick, disabled = false , radius = false , icon = '' , iconPosition = 'right', status = ''}) => {
    let scale = 1;
    let fontSize = '16px';
    let fontWeight = 400;

    if (size === 'sm') {
        scale = 0.75;
        fontSize = '14px';
    }

    if (size === 'lg') {
        scale = 1.5;
        fontSize = '18px';
        fontWeight = 600;
    }

    const style = {
        padding: `${scale * 0.5}rem ${scale * 1}rem`,
        fontSize,
        fontWeight,
    };

    return (
        <button
            onClick={handleClick}
            style={style}
            className={`tapps-btn btn-${type} ${disabled ? 'disabled' : ''} ${radius ? 'radius' : ''} ${icon ? 'withIcon' : ''} ${status ? `status-${status}` : '' }`}
            disabled={disabled}
        >
            {
                icon && iconPosition === 'left' &&
                <i className={`iconwhite-${icon}`} />
            }
            {label}
            {
                icon && iconPosition === 'right' &&
                <i className={`iconwhite-${icon}`} />
            }
        </button>
    );
};

export default Button;
